export default __webpack_public_path__ + "static/media/819.7a9e017a.png";